import { Badge } from "@/components/ui/badge";
import { Globe, UserPlus2 } from 'lucide-react';

interface LeadBadgeProps {
  leadSource: string;
}

export const LeadBadge = ({ leadSource }: LeadBadgeProps) => {
  if (leadSource === 'Website Quote Form') {
    return (
      <Badge variant="secondary" className="flex items-center gap-1 bg-[#F1F0FB] text-primary border-none">
        <Globe className="h-3 w-3" />
        Website Lead
      </Badge>
    );
  }
  return (
    <Badge variant="outline" className="flex items-center gap-1">
      <UserPlus2 className="h-3 w-3" />
      Manual Entry
    </Badge>
  );
};